<template>
	<NuxtPage />
</template>

<script type="ts" setup>
	import {definePageMeta} from '#imports';
	import {isValidRieIdParam} from '~/lib/validators/rieId';

	definePageMeta({
		validate: isValidRieIdParam
	});
</script>
